import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const RefDataDefaultConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_REF_DATA_DEFAULT_CONFIGS:
            return {
                ...state,
                refDataDropdowns: action.payload,
                refDataDropdownsForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.label,
                    value: item.value,
                })),
            };
        default:
            return state;
    }
};

export default RefDataDefaultConfigurationReducer;
